import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
import { toast } from 'react-toastify';

export class PriceListsEdit extends React.Component {
  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    priceList: {},
    priceListDetails: [],
    external: false
  }

  componentWillMount() {
    this.fetchPriceList();
    this.fetchPriceListDetails()
  }

  handleChange (evt) {
    var priceListDetails = this.state.priceListDetails
    var index = priceListDetails.findIndex(e => e.productID == evt.target.name);
    if (!isNaN(evt.target.value)) {
      priceListDetails[index].customPrice = evt.target.value.trim()
    } else {
      if (!priceListDetails[index].customPrice) {
        priceListDetails[index].customPrice = ''
      }
    }
    this.setState({ priceListDetails: priceListDetails });
  }

  fetchPriceList = async () => {
    axios.get('/pricelists/' + this.props.match.params.id)
        .then(data => {
          console.log(data);
          this.setState({
            priceList: data[0]
          });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch price list')
        })
  }

  fetchPriceListDetails = async () => {
    axios.get('/pricelists/' + this.props.match.params.id + '/details')
        .then(data => {
          console.log(data);
          var external = data.find((e)=> {return e.extData != null})
          this.setState({
            priceListDetails: data,
            external: external
          });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch price list details')
        })
  }

  saveChanges = async () => {
    let requestParams = {
      'priceListID': this.props.match.params.id,
      'priceListDetails': this.state.priceListDetails
    }
    axios.post('/pricelists/details/edit', requestParams)
        .then(data => {
          console.log(data);
          toast.success('Price List Updated!')
          this.props.history.push("/pricelists")
        })
          .catch (err => {
            console.log(err)
            Rollbar.error(err)
            toast.error('Failed to save price list changes')
          })
  }

  editPrice(cell, row, enumObject, rowIndex) {
    return (
      <input type="text" className="form-control" name={row.productID} value={row.customPrice ? row.customPrice : ''} onChange={this.handleChange} disabled={this.state.external}/>
    )
  }

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
            <h1 className="h3">Edit Price List - <span className="text-success">{this.state.priceList.priceListName}</span><span className="ml-3">{this.state.external ? <span className="badge badge-warning">External</span> : null}</span></h1>
            </div>
            <button type="button" onClick={() => this.saveChanges()} className="btn btn-success btn-sm mar-bot mar-right" disabled={this.state.external}>Save Changes</button>
            <BootstrapTable data={this.state.priceListDetails} striped={true} hover={true} pagination>
              <TableHeaderColumn dataField="productName" isKey={true} dataSort={true} filter={{ type: 'TextFilter' }}>Product Name</TableHeaderColumn>
              <TableHeaderColumn dataField="categoryName" dataSort={true} filter={{ type: 'TextFilter' }}>Product Category</TableHeaderColumn>
              <TableHeaderColumn dataField="basePrice" dataSort={true}>Base Price</TableHeaderColumn>
              <TableHeaderColumn dataSort={true} dataFormat={this.editPrice.bind(this)}>Custom Price</TableHeaderColumn>
            </BootstrapTable>
          </div>
        );
    }
}
